import { render } from "./SummaryCard.vue?vue&type=template&id=6166b730&scoped=true&ts=true"
import script from "./SummaryCard.vue?vue&type=script&lang=ts"
export * from "./SummaryCard.vue?vue&type=script&lang=ts"

import "./SummaryCard.vue?vue&type=style&index=0&id=6166b730&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6166b730"]])

export default __exports__